import { FC } from "react";
import { Group, Loader } from "@mantine/core";

const SuspenseLoader: FC = () => {

  return (
    <Group position="center" grow style={{ height: 400 }}>
      <Loader size={128} />
    </Group>
  );
};

export default SuspenseLoader;
